import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { CircularProgress } from '@mui/material';

import PageTitle from '@/shared/components/layouts/PageTitle';
import { AppPath } from '@/shared/constants/path';

type TitleProps = {
  customerId: string;
  isLoading: boolean;
  onSaveCustomer: () => void;
};

const Title: FC<TitleProps> = ({
  customerId,
  isLoading,
  onSaveCustomer,
}) => {
  const label = customerId.split('-')[0];

  const { t } = useTranslation(['customers', 'common']);

  return (
    <PageTitle
      title={{
        text: `${t('customers:customerID')}: ${label}`,
        tooltip: {
          title: customerId,
          placement: 'right-end',
          arrow: true,
        },
      }}
      breadcrumbs={[
        {
          label: 'Customers',
          icon: (
            <PeopleAltIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
          to: AppPath.Customers,
        },
        {
          label: label,
          icon: (
            <PeopleAltIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
          tooltip: {
            title: customerId,
            placement: 'right-end',
            arrow: true,
          },
        },
      ]}
      actions={[
        {
          label: t('common:save'),
          icon: isLoading && <CircularProgress color='inherit' size={16} />,
          button: {
            size: 'large',
            variant: 'contained',
            onClick: () => {
              if (isLoading) return;

              void onSaveCustomer();
            },
            sx: { gap: 1 },
          },
        },
      ]}
    />
  );
};

export default Title;
